import { fetchQuerySuggestions } from '../../features/query-suggest/query-suggest-actions.js';
import { logSearchboxSubmit, searchboxSubmit, } from '../../features/query/query-analytics-actions.js';
import { executeSearch } from '../../features/search/search-actions.js';
import { buildCoreSearchBox, } from '../core/search-box/headless-core-search-box.js';
/**
 * Creates a `SearchBox` controller instance.
 *
 * @param engine - The headless engine.
 * @param props - The configurable `SearchBox` properties.
 * @returns A `SearchBox` controller instance.
 *
 * @group Controllers
 * @category SearchBox
 */
export function buildSearchBox(engine, props = {}) {
    const searchBox = buildCoreSearchBox(engine, {
        ...props,
        executeSearchActionCreator: executeSearch,
        fetchQuerySuggestionsActionCreator: fetchQuerySuggestions,
        isNextAnalyticsReady: true,
    });
    return {
        ...searchBox,
        submit() {
            searchBox.submit(logSearchboxSubmit(), searchboxSubmit());
        },
        get state() {
            return searchBox.state;
        },
    };
}
